import { ATTRIBUTE_CATEGORY_ICONS } from 'dashboard/routes/dashboard/settings/attributes/constants';

export const eventAttributePickerOptions = ({
  attributes = [],
  categories = [],
  t,
}) => {
  const catsById = {};
  categories.forEach(category => {
    catsById[category.id] = category;
  });

  return attributes
    .filter(attr => !attr.discarded_at)
    .map(attr => {
      let categoryKey = (attr.attribute_category || 'other').toLowerCase();
      let categoryLabel = t(
        `ATTRIBUTES_MGMT.ATTRIBUTE_CATEGORIES.${categoryKey.toUpperCase()}`
      );

      if (attr.custom_attribute_category_id) {
        const sub = catsById[attr.custom_attribute_category_id];
        if (sub) {
          categoryKey = (sub.parent_category || categoryKey).toLowerCase();
          categoryLabel = sub.name || categoryLabel;
        }
      }

      return {
        value: attr.attribute_key,
        label: attr.attribute_display_name || attr.attribute_key,
        icon:
          ATTRIBUTE_CATEGORY_ICONS[categoryKey] ||
          ATTRIBUTE_CATEGORY_ICONS.other,
        categoryLabel,
      };
    });
};
